import { Component, Input, OnInit } from '@angular/core';
import { AlliancesService } from '@app/core/services/alliances.service';

@Component({
  selector: 'app-to-sign-form',
  templateUrl: './to-sign-form.component.html',
  styleUrls: ['./to-sign-form.component.css'],
})
export class ToSignFormComponent implements OnInit {
  @Input() infoLead: any;

  constructor(private srvAlliances: AlliancesService) {}

  ngOnInit(): void {
    this.infoLead = {
      name: '',
      contactEmail: '',
      contactName: '',
      contactPhone: '',
      city: '',
      section: '',
      arquetipo: '',
      firstContactDate: '',
    };
  }
}
